import type { SecondaryMarketAmendLiveFetched } from 'state/secondaryMarket/live/form/original/liveOriginalForm.actions';
import { originalFormReducerFactory } from 'state/secondaryMarket/shared/form/original/original.reducer';

import type { LiveForm } from '../input/inputForm.model';
import type { SecondaryMarketLiveReloadedForm } from './liveOriginalForm.model';
import { initialLiveReloadedFormMap } from './liveOriginalForm.model';

export const liveOriginalFormReducer = originalFormReducerFactory<
  LiveForm,
  SecondaryMarketLiveReloadedForm,
  'LIVE',
  SecondaryMarketAmendLiveFetched
>('LIVE', initialLiveReloadedFormMap, 'live', (action: SecondaryMarketAmendLiveFetched) => ({
  accruedInterest: action.data.accruedInterest,
  customizedXMarginAdjustment: action.data.salesMarginAdjusted,
  customizedUpfront: action.data.upfrontFeeAdjusted,
  customizedTradingPriceAdjustment: action.data.tradingPriceAdjusted,
  upfront: action.data.upFront,
  settlementPrice: action.data.settlementPrice,
}));
